<template>
  <div id="dashboard">
    <Admin
      class="main"
      v-bind:class="{
        'tw-bg-light-gray': summaryAll != null && summaryAll.countsDocsAll > 0,
      }"
    >
      <v-main>
        <v-container
          fluid
          v-if="summaryAll != null && summaryAll.countsDocsAll > 0"
        >
          <v-row justify="center">
            <v-col md="12">
              <div class="wrapper">
                <div class="tw-text-xl tw-font-bold tw-mb-3">ยอดขาย</div>
                <div class="graph">
                  <chart></chart>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="6">
              <div class="wrapper">
                <div class="tw-text-xl tw-font-bold tw-mb-3">ยอดภาษีขาย</div>
                <div class="summary">
                  <div
                    style="
                      background-color: #4abeef;
                      width: 60px;
                      height: 60px;
                      padding: 15px;
                      display: inline-block;
                      float: left;
                    "
                    class="rounded-circle"
                  >
                    <img src="/images/icons/icon_vat.svg" />
                  </div>
                  <div style="margin-left: 80px">
                    <span
                      >ยอดภาษีขายของเดือน
                      {{ getMonthFromYearMonth(selectedYearMonth) }}</span
                    >
                    <div class="price">
                      {{
                        (summaryMonth.salesTaxAmount / 100)?.toLocaleString()
                      }}
                      ฿
                    </div>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col md="6">
              <div class="wrapper">
                <div class="tw-text-xl tw-font-bold tw-mb-3">ยอดเอกสาร</div>
                <div class="summary">
                  <div
                    style="
                      background-color: #f5bc1c;
                      width: 60px;
                      height: 60px;
                      padding: 15px;
                      display: inline-block;
                      float: left;
                    "
                    class="rounded-circle"
                  >
                    <img
                      src="/images/icons/sumdoc.svg"
                      width="100"
                      height="100"
                    />
                  </div>
                  <div style="margin-left: 80px">
                    <span
                      >ยอดเอกสารของเดือน
                      {{ getMonthFromYearMonth(selectedYearMonth) }}</span
                    >
                    <div class="docs">
                      {{ summaryMonth.countsDocsAll?.toLocaleString() }} รายการ
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <div
          v-if="
            summaryAll != null &&
            (!summaryAll.countsDocsAll || summaryAll.countsDocsAll === 0)
          "
        >
          <div
            class="tw-container tw-mx-auto fit-screen-div tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-text-center"
          >
            <div>
              <img src="/images/icons/db-connection.svg" class="mx-auto" />
              <p class="tw-w-full tw-pt-5">
                คุณยังไม่ได้เชื่อมต่อกับโปรแกรม <strong>e-Tax DB</strong>
              </p>
              <a href="">
                <button
                  class="tw-bg-light-blue tw-text-white tw-px-20 tw-py-4 tw-rounded-md"
                >
                  ดาวน์โหลด e-Tax DB
                </button>
              </a>
              <p
                class="tw-border-t tw-border-gray-500 tw-pt-5 tw-mt-5 tw-max-w-lg tw-mx-auto"
              >
                คุณยังไม่ได้เชื่อมต่อกับโปรแกรม e-Tax DB
                <a href="" class="tw-text-light-blue">ดาวน์โหลด</a>
              </p>
            </div>
          </div>
        </div>
      </v-main>
    </Admin>
  </div>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import Chart from "@/components/admin/dashboard/chart";
import { mapState } from "vuex";
import moment from "moment";
import logActivity from "@/libs/activityLogger";

export default {
  name: "Dashboard",
  components: {
    Admin,
    Chart,
  },
  computed: mapState({
    // erpList: state => state.databasesByCompany.erpList,
    selectedSummaryDate: (state) =>
      state.summariesByCompany.selectedSummaryDate,
    selectedYearMonth: (state) => state.summariesByCompany.selectedYearMonth,
    summaryMonth: (state) => state.summariesByCompany.summaryMonth,
    summaryAll: (state) => state.summariesByCompany.summaryAll,
    isItemLoading: (state) => state.drawer.isItemLoading,
    selectedCompanyProductList: (state) =>
      state.companies.selectedCompanyProductList,
  }),
  created() {
    this.query();
    this.getCompanyProductList();
    // this.redirectToNewPage();
  },
  methods: {
    getCompanyProductList() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    isValid(value) {
      return (
        value !== undefined && value !== null && value !== "" && value === true
      );
    },
    getMonthFromYearMonth: function (selectedYearMonth) {
      return moment(selectedYearMonth, "YYYY-MM").format("MMMM");
    },
    query: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        // this.$store.dispatch('databasesByCompany/getData', {id: companyId})
        this.$store.dispatch("summariesByCompany/getSummaryAll", { companyId });
      }
    },
    redirectToExchangeRate: function () {
      this.$router.push({ name: "Company.ExchangeRate" });
    },
    redirectToAiDoc: function () {
      this.$router.push({ name: "Company.reportDocumentAI" });
    },
    redirectToApAutomate: function () {
      this.$router.push({ name: "Company.AccountsPayable" });
    },
    redirectToTKC: function () {
      this.$router.push({ name: "Company.DocumentTOPSERV" });
    },
    redirectToNsThaiSmartTax: function () {
      this.$router.push({ name: "Company.WithholdingTax" });
    },
    goToDefaultPage(products) {
      if (products.isEtax) {
        return "";
      }
      if (products.isNsThaiSmartTax) {
        return this.redirectToNsThaiSmartTax()
      }
      if (products.isApAutomate) {
        return this.redirectToApAutomate()
      }
      if (products.isPdfDoc) {
        return this.redirectToAiDoc()
      }
      if (products.isExchangeRate) {
        return this.redirectToExchangeRate()
      }
      if (products.isTopserv) {
        return this.redirectToTKC()
      }

      // Default if none match
      return "";
    },
  },
  beforeDestroy() {
    // this.$store.dispatch('databasesByCompany/getDataListUnsubscribe')
    this.$store.dispatch("summariesByCompany/getSummaryMonthUnsubscribe");
    this.$store.dispatch("summariesByCompany/getSummaryAllUnsubscribe");
    this.$store.dispatch("summariesByCompany/getSummaryDayFirstUnsubscribe");
    this.$store.dispatch("summariesByCompany/getSummaryDaySecondUnsubscribe");
  },
  watch: {
    selectedCompanyProductList(newValue, oldValue) {
      // console.log(
      //   `selectedCompanyProductList changed from "${oldValue}" to "${newValue}"`
      // );

      this.goToDefaultPage(this.selectedCompanyProductList)

    },
  },
  mounted() {
    logActivity("page_view", { page_title: "Dashboard" });
  },
};
</script>

<style lang="scss">
#dashboard {
  .wrapper {
    margin: 0 20px 0;
    padding: 0 10px 0;

    .graph {
      background: #ffffff;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    }

    .summary {
      width: 100%;
      max-width: 475px;
      background: #ffffff;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      padding: 20px;
      align-items: center;

      .price {
        color: #4abeef;
        font-size: 24px;
        font-weight: bold;
      }
      .docs {
        color: #f5bc1c;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
}
.fit-screen-div {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
</style>
